<template>
  <div class="overflow-hidden">
    <div
      :class="[
        $style.grid,
        'grid min-w-full gap-2 overflow-x-auto pb-4',
      ]"
    >
      <template v-for="label in labels" :key="label">
        <div :class="[$style.squareHack]">
          <div
            :class="[
              'absolute inset-0 flex items-center justify-center rounded-lg border border-primary bg-primary font-medium',
              getCellOpacityClass(label),
              getTextColor(getDataForLabel(label)),
            ]"
          >
            <div>
              <p class="mb-0 text-center text-lg">
                {{
                  showValues
                    ? getDataForLabel(label)
                    : label
                }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <template v-if="showValues">
        <template v-for="label in labels" :key="label">
          <div
            class="flex items-center justify-around overflow-hidden"
          >
            <span class="text-xs">
              {{ label }}
            </span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
type HeatmapChartLabel = number | string
type HeatmapChartRow = {
  x: HeatmapChartLabel
  y: number
}

const props = defineProps<{
  labels: Array<HeatmapChartLabel>
  data: HeatmapChartRow[]
  showValues?: boolean
}>()

const dataMax = computed(() =>
  Math.max(...props.data.map(({ y }) => y))
)

const numberOfLabels = computed(
  () => props.labels.length || 0
)

const getCellOpacity = (yValue: number) =>
  Math.ceil((yValue / dataMax.value) * 20) * 5 || 0

const getCellOpacityClass = (label: HeatmapChartLabel) =>
  `bg-opacity-${getCellOpacity(getDataForLabel(label))}`

const getTextColor = (yValue: number) =>
  (Math.ceil((yValue / dataMax.value) * 20) * 5 || 0) >= 40
    ? "text-primary-fg"
    : "text-primary"

const getDataForLabel = (label: HeatmapChartLabel) =>
  props.data.find(({ x }) => x === label)?.y ?? 0
</script>

<style lang="scss" module>
.squareHack {
  position: relative;
  padding-top: 100%;
}

.grid {
  grid-template-columns: repeat(
    v-bind("numberOfLabels"),
    1fr
  );
}
</style>
